import React from 'react';

const HomePage: React.FC = () => {
  return (
    <div className="bg-gray-100 min-h-screen flex items-center justify-center"> {/* Centered the content */}
      <div className="bg-white p-12 rounded-lg shadow-lg max-w-2xl h-auto sm:h-[500px] flex flex-col items-center justify-center text-center"> {/* Added flex, items-center, and justify-center */}
        <h1 className="text-5xl font-semibold tracking-tight text-gray-900 sm:text-7xl">
          Welcome to Neighbourhood.me!
        </h1>
        <p className="mt-8 text-lg font-medium text-gray-500 sm:text-xl">
          Your one-stop solution for managing and monetizing WhatsApp and more.
        </p>
        <div className="mt-10 flex items-center justify-center gap-x-6">
          <a
            href="#"
            className="rounded-md bg-indigo-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-xs hover:bg-indigo-500 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
          >
            Get started
          </a>
        </div>
      </div>
    </div>
  );
};

export default HomePage;